import {getLocale} from '@epic-core/common';
import axios from 'axios';
import {getOrigin} from 'epic-fortnite-shared-values';
import useSWR from 'swr';

import {SACStatus, Island} from '../../server/handlers/creative-form/creative.types';

export const urls = () => {
  const origin = getOrigin();

  const urls = {
    SAC_STATUS: (locale) => `${origin}/${locale}/api/creative-submission-form/sac-status`,
    PUBLISHED_ISLANDS: (locale) =>
      `${origin}/${locale}/api/creative-submission-form/published-islands`,
  };

  return urls;
};

export const useSACStatus = (isLoggedIn: boolean) => {
  const locale = getLocale();

  const url = urls().SAC_STATUS(locale);
  return useSWR<SACStatus>(url, (url) => axios.get(url).then((response) => response.data));
};

export const usePublishedIslands = () => {
  const locale = getLocale();
  const url = urls().PUBLISHED_ISLANDS(locale);
  return useSWR<{
    islands: Island[];
    config: {pendingSubmissionsLimit: number; multiSubmissionsEnabled: boolean};
  }>(url, (url) => axios.get(url).then((response) => response.data));
};
